export default __webpack_public_path__ + "static/pexels-km-l-3999647_-0ad9851b4da5d76ca9a8282e9a28fe62.jpg";